<app-cardpage-base [loading]="loading">
  <p-card class="card-layout block h-full min-h-0 w-full"
          styleClass="flex h-full min-h-0 flex-col">
    <ng-template #title>
      <div class="grid grid-cols-2 content-center gap-4">
        <span class="text-xl font-bold">{{ patient.name }}</span>
        <div class="flex flex-row gap-4 justify-self-end">
          <p-button variant="outlined" icon="pi pi-file-edit" [label]="'reportCreate' | translate" (click)="cr.toggle($event)" />
          <p-popover #cr>
            <div class="flex flex-col gap-3 p-1">
              <span class="text-surface-900 mb-2 block text-sm font-medium dark:text-surface-0">
                Seleziona il periodo:
              </span>
              <p-floatlabel variant="on">
                <p-datepicker [(ngModel)]="startDate" inputId="startDate" showIcon iconDisplay="input" [showTime]="true" />
                <label for="startDate">{{ 'from' | translate}}</label>
              </p-floatlabel>
              <p-floatlabel variant="on">
                <p-datepicker [(ngModel)]="endDate" inputId="endDate" showIcon iconDisplay="input" [showTime]="true" />
                <label for="endDate">{{ 'to' | translate}}</label>
              </p-floatlabel>

              <div class="mt-2 flex justify-end gap-2">
                <p-button [label]="'primeng.cancel' | translate" severity="secondary" size="small" (click)="cr.hide()" />
                <p-button [label]="'confirm' | translate" size="small" (click)="onCreateReport(cr)" />
              </div>
            </div>
          </p-popover>
        </div>
      </div>
    </ng-template>
    <ng-template #subtitle>
      <div class="flex flex-row items-center gap-5">
        <span>{{ 'lastAccess' | translate }}: {{ patient.logInfo | statusDate }}</span>
        <span>{{ 'parameters.metrics' | translate }}: {{ patient.metrics.date | dateOnly }}</span>
      </div>
    </ng-template>

    <div class="flex h-full min-h-0 flex-col gap-4 pb-4">
      <span class="text-lg font-semibold">{{ 'titles.dailyMetrics' | translate }}</span>
      <div class="grid grid-cols-6 gap-4">
        <p-panel class="text-xs">
          <ng-template #header>
            <div class="flex items-center gap-1 text-sm font-semibold">
              <i class="pi pi-heart"></i>
              <span>{{ 'parameters.heartrate' | translate }}</span>
            </div>
          </ng-template>
          <div class="flex flex-col">
            <div class="flex gap-4">
              <div class="flex flex-col">
                <span class="justify-end text-xs">{{ 'parameters.rest' | translate }}</span>
                <div class="flex items-end gap-2">
                  <span class="text-3xl font-semibold">{{ patient.metrics.fcrValue }}</span>
                  <span class="text-sm">bpm</span>
                </div>
              </div>
              <app-trend-indicator class="self-center" [value]="patient.metrics.fcrDelta" type="FC" />
            </div>
            <p-divider />
            <div class="flex gap-4">
              <div class="flex flex-col">
                <span class="justify-end text-xs">{{ 'parameters.movement' | translate }}</span>
                <div class="flex items-baseline gap-2">
                  <span class="text-3xl font-semibold">{{ patient.metrics.fcmValue }}</span>
                  <span class="text-sm">bpm</span>
                </div>
              </div>
              <app-trend-indicator class="self-center" [value]="patient.metrics.fcmDelta" type="FC" />
            </div>
          </div>
        </p-panel>

        <p-panel class="text-xs">
          <ng-template #header>
            <div class="flex items-center gap-1 text-sm font-semibold">
              <i class="pi pi-arrows-h"></i>
              <span>{{ 'parameters.breathfrequency' | translate }}</span>
            </div>
          </ng-template>
          <div class="flex flex-col">
            <div class="flex gap-4">
              <div class="flex flex-col">
                <span class="justify-end text-xs">{{ 'parameters.rest' | translate }}</span>
                <div class="flex items-end gap-2">
                  <span class="text-3xl font-semibold">{{ patient.metrics.frrValue }}</span>
                  <span class="text-sm">rpm</span>
                </div>
              </div>
              <app-trend-indicator class="self-center" [value]="patient.metrics.frrDelta" type="FR" />
            </div>
            <p-divider />
            <div class="flex gap-4">
              <div class="flex flex-col">
                <span class="justify-end text-xs">{{ 'parameters.movement' | translate }}</span>
                <div class="flex items-baseline gap-2">
                  <span class="text-3xl
                        font-semibold">{{ patient.metrics.frmValue }}</span>
                  <span class="text-sm">rpm</span>
                </div>
              </div>
              <app-trend-indicator class="self-center" [value]="patient.metrics.frmDelta" type="FR" />
            </div>
          </div>
        </p-panel>

        <p-panel class="text-xs">
          <ng-template #header>
            <div class="flex items-center gap-1 text-sm font-semibold">
              <i class="pi pi-circle"></i>
              <span>{{ 'parameters.saturation' | translate }}</span>
            </div>
          </ng-template>
          <div class="flex flex-col">
            <div class="flex gap-4">
              <div class="flex flex-col">
                <span class="justify-end text-xs">{{ 'parameters.rest' | translate }}</span>
                <div class="flex items-end gap-2">
                  <span class="text-3xl font-semibold">{{ patient.metrics.o2RValue }}</span>
                  <span class="text-sm">%</span>
                </div>
              </div>
              <app-trend-indicator class="self-center" [value]="patient.metrics.o2RDelta" type="O2" />
            </div>
            <p-divider />
            <div class="flex gap-4">
              <div class="flex flex-col">
                <span class="justify-end text-xs">{{ 'parameters.movement' | translate }}</span>
                <div class="flex items-baseline gap-2">
                  <span class="text-3xl
                        font-semibold">{{ patient.metrics.o2MValue }}</span>
                  <span class="text-sm">%</span>
                </div>
              </div>
              <app-trend-indicator class="self-center" [value]="patient.metrics.o2MDelta" type="O2" />
            </div>
          </div>
        </p-panel>

        <p-panel class="text-xs">
          <ng-template #header>
            <div class="flex items-center gap-1 text-sm font-semibold">
              <i class="pi pi-stopwatch"></i>
              <span>{{ 'monitoringHours' | translate }}</span>
            </div>
          </ng-template>
          <div class="flex flex-col">
            <div class="flex gap-4">
              <div class="flex flex-col">
                <span class="justify-end text-xs">{{ 'parameters.rest' | translate }}</span>
                <div class="flex items-end gap-2">
                  <span class="text-3xl font-semibold">{{ patient.metrics.minutesRst | duration }}</span>
                  <span class="text-sm">hh:mm</span>
                </div>
              </div>
            </div>
            <p-divider />
            <div class="flex gap-4">
              <div class="flex flex-col">
                <span class="justify-end text-xs">{{ 'parameters.movement' | translate }}</span>
                <div class="flex items-baseline gap-2">
                  <span class="text-3xl font-semibold">{{ patient.metrics.minutesMov | duration }}</span>
                  <span class="text-sm">hh:mm</span>
                </div>
              </div>
            </div>
          </div>
        </p-panel>

        <p-panel class="text-xs">
          <ng-template #header>
            <div class="flex items-center gap-1 text-sm font-semibold">
              <i class="pi pi-exclamation-triangle"></i>
              <span>{{ 'alerts' | translate }}</span>
            </div>
          </ng-template>
          <div class="flex flex-col">
            <div class="flex gap-4">
              <div class="flex flex-col">
                <span class="justify-end text-xs">{{ 'toAnalyse' | translate }}</span>
                <div class="flex items-end gap-2">
                  <span class="text-3xl font-semibold text-red-600">{{ alertsToAnalyse }}</span>
                </div>
              </div>
              <p-button class="self-end" variant="text" icon="pi pi-arrow-right" (click)="tabsId = '1'"></p-button>
            </div>
            <p-divider />
            <div class="flex gap-4">
              <div class="flex flex-col">
                <span class="justify-end text-xs">{{ 'lastMonth' | translate }}</span>
                <div class="flex items-baseline gap-2">
                  <span class="text-3xl font-semibold">{{ patient.alerts30 }}</span>
                </div>
              </div>
            </div>
          </div>
        </p-panel>

        <p-panel class="text-xs">
          <ng-template #header>
            <div class="flex items-center gap-1 text-sm font-semibold">
              <i class="pi pi-exclamation-triangle"></i>
              <span>{{ 'reportCreated' | translate }}</span>
            </div>
          </ng-template>
          <div class="flex flex-col">
            <div class="flex gap-4">
              <div class="flex flex-col">
                <span class="justify-end text-xs">{{ 'last24h' | translate }}</span>
                <div class="flex items-end gap-2">
                  <span class="text-3xl font-semibold">{{ patient.reports24 }}</span>
                </div>
              </div>
              <p-button class="self-end" variant="text" icon="pi pi-arrow-right" (click)="tabsId = '6'"></p-button>
            </div>
            <p-divider />
            <div class="flex gap-4">
              <div class="flex flex-col">
                <span class="justify-end text-xs">{{ 'lastMonth' | translate }}</span>
                <div class="flex items-baseline gap-2">
                  <span class="text-3xl font-semibold">{{ patient.reports30 }}</span>
                </div>
              </div>
            </div>
          </div>
        </p-panel>
      </div>

      <div class="flex h-full min-h-0 flex-col">
        <p-tabs [(value)]="tabsId">
          <p-tablist>
            <p-tab value="0">{{ 'titles.vitalParameters' | translate}}</p-tab>
            <p-tab value="1">{{ 'alerts' | translate}}</p-tab>
            @if (hasGait) {
            <p-tab value="2">{{ 'functions.gait' | translate}}</p-tab>
            }
            @if (hasPosture) {
            <p-tab value="3">{{ 'functions.posture' | translate}}</p-tab>
            <p-tab value="4">{{ 'functions.romberg' | translate}}</p-tab>
            }
            @if (hasBreath) {
            <p-tab value="5">{{ 'functions.breath' | translate }}</p-tab>
            }
            <p-tab value="6">Report</p-tab>
          </p-tablist>
          <p-tabpanels>
            <p-tabpanel value="0">
              <div class="flex flex-col gap-2">
                <div class="flex flex-row items-center gap-2">
                  <p-selectbutton #sb
                                  [options]="timeOptions" [(ngModel)]="selectedTime"
                                  optionLabel="label" optionValue="value"
                                  (onChange)="onTimeTypeChange($event, sb.el.nativeElement, op)" />

                  <div class="flex grow flex-row items-center justify-end gap-1">
                    <p-chip [label]="'parameters.rest' | translate" icon="pi pi-circle-fill" class="bg-blue-50! **:text-blue-700!" />
                    <p-chip [label]="'parameters.movement' | translate" icon="pi pi-circle-fill" class="bg-red-50! **:text-red-700!" />
                  </div>
                </div>

                <div class="grid grid-cols-2 gap-3">
                  <app-trend icona="pi pi-heart" titolo="parameters.meanheartrate" [colorRest]="'--color-blue-700'" [colorMovement]="'--color-red-700'" [segnale]="patient.fcGraphs" [loading]="loadingMetrics"
                             [minX]="min" [maxX]="max"
                             (onZoomChanged)="onZoomChanged($event)" (onZoomCommand)="onZoomCommand($event)"
                             [zoomLevel]="zoomLevel.asObservable()" [zoomCommand]="zoomCommand.asObservable()">
                    <!--[minY]="0" [maxY]="230">-->
                  </app-trend>
                  <app-trend icona="pi pi-arrows-h" titolo="parameters.meanbreathrate" [colorRest]="'--color-blue-700'" [colorMovement]="'--color-red-700'" [segnale]="patient.frGraphs" [loading]="loadingMetrics"
                             [minX]="min" [maxX]="max"
                             (onZoomChanged)="onZoomChanged($event)" (onZoomCommand)="onZoomCommand($event)"
                             [zoomLevel]="zoomLevel.asObservable()" [zoomCommand]="zoomCommand.asObservable()">
                    <!--[minY]="0" [maxY]="100">-->
                  </app-trend>
                  <app-trend icona="pi pi-circle" titolo="parameters.meanspo2" [colorRest]="'--color-blue-700'" [colorMovement]="'--color-red-700'" [segnale]="patient.o2Graphs" [loading]="loadingMetrics"
                             [minX]="min" [maxX]="max"
                             (onZoomChanged)="onZoomChanged($event)" (onZoomCommand)="onZoomCommand($event)"
                             [zoomLevel]="zoomLevel.asObservable()" [zoomCommand]="zoomCommand.asObservable()">
                    <!--[minY]="0" [maxY]="100">-->
                  </app-trend>

                  <p-panel>
                    <div class="grid grid-cols-3 justify-items-stretch gap-3">
                      <p-button [label]="'titles.synopticTable' | translate" styleClass="w-full" (click)="onShowSynopticTable()" />
                      <p-button class="col-1" [label]="'titles.hearthSignals' | translate" styleClass="w-full" (click)="onShowHearthSignals()" />
                      <p-button [label]="'titles.breathSignals' | translate" styleClass="w-full" (click)="onShowBreathSignals()" />
                      <p-button [label]="'titles.accSignals' | translate" styleClass="w-full" (click)="onShowAccelerometerSignals()" />
                    </div>
                  </p-panel>
                </div>
              </div>

              <p-popover #op>
                <div class="flex flex-col gap-3 p-1">
                  <span class="text-surface-900 mb-2 block text-sm font-medium dark:text-surface-0">
                    Seleziona il periodo:
                  </span>
                  <!-- Calendar/DatePicker per il range di date -->
                  <p-datepicker [(ngModel)]="customDateRange"
                                selectionMode="range"
                                [inline]="true"
                                [showButtonBar]="true" />

                  <div class="mt-2 flex justify-end gap-2">
                    <p-button [label]="'primeng.cancel' | translate" severity="secondary" size="small" (click)="op.hide()" />
                    <p-button [label]="'confirm' | translate" size="small" (click)="confirmCustomRange(op)" />
                  </div>
                </div>
              </p-popover>
            </p-tabpanel>

            <p-tabpanel value="1">
              <p-table [value]="alerts"
                       [paginator]="true" [rows]="10" [rowsPerPageOptions]="[5, 10, 25]"
                       [scrollable]="true" scrollHeight="flex"
                       stripedRows
                       class="flex h-full min-h-0 flex-col">
                <ng-template #header>
                  <tr>
                    <th pSortableColumn="timeStamp" style="width: 15%">
                      <div class="flex items-center gap-2">
                        {{ 'date' | translate }}
                        <p-sort-icon field="timeStamp" />
                      </div>
                    </th>
                    <th style="width: 40%">{{ 'alert' | translate}}</th>
                    <th style="width: 15%">{{ 'value' | translate}}</th>
                    <th pSortableColumn="isChecked" style="width: 15%">
                      <div class="flex items-center justify-center gap-2">
                        {{ 'verified' | translate}}
                        <p-sort-icon field="isChecked" />
                      </div>
                    </th>
                    <th></th>
                  </tr>
                </ng-template>
                <ng-template #body let-alert>
                  <tr>
                    <td>{{ alert.timeStamp | statusDate }}</td>
                    <td>{{ 'alertCodes.' + alert.description | translate }}</td>
                    <td>{{ getAlertValue(alert) }}</td>
                    <td>
                      @if(alert.isChecked) {
                      <div class="flex justify-center">
                        <i class="pi pi-check"></i>
                      </div>
                      }
                    </td>
                    <td>
                      <div class="flex justify-end">
                        <p-button icon="pi pi-pencil" (click)="onAlertEdit(alert)"></p-button>
                      </div>
                    </td>
                  </tr>
                </ng-template>
                <ng-template #emptymessage>
                  <tr>
                    <td colspan="5">{{ 'primeng.emptyMessage' | translate }}</td>
                  </tr>
                </ng-template>
              </p-table>
            </p-tabpanel>

            @if (hasGait) {
            <p-tabpanel value="2">
            </p-tabpanel>
            }

            @if (hasPosture) {
            <p-tabpanel value="3">
            </p-tabpanel>

            <p-tabpanel value="4">
            </p-tabpanel>
            }

            @if (hasBreath) {
            <p-tabpanel value="5">
              <p-table [value]="breathSessions"
                       [paginator]="true" [rows]="10" [rowsPerPageOptions]="[5, 10, 25]"
                       [scrollable]="true" scrollHeight="flex"
                       stripedRows
                       class="flex h-full min-h-0 flex-col">
                <ng-template #header>
                  <tr>
                    <th pSortableColumn="timeStamp" style="width: 20%">
                      <div class="flex items-center gap-2">
                        {{ 'date' | translate }}
                        <p-sort-icon field="timeStamp" />
                      </div>
                    </th>
                    <th class="!text-center" style="width: 10%">{{ 'session' | translate }}</th>
                    <th class="!text-center" style="width: 10%">{{ 'exQuantity' | translate }}</th>
                    <th style="width: 10%">
                      <div class="flex flex-col items-center">
                        <span>{{ 'parameters.duration' | translate }}</span>
                        <span class="text-xs font-normal">[mm:ss]</span>
                      </div>
                    </th>
                    <th style="width: 30%">{{ 'notes' | translate }}</th>
                    <th></th>
                  </tr>
                </ng-template>
                <ng-template #body let-session>
                  <tr>
                    <td>{{ session.timeStamp | date:'medium' }}</td>
                    <td class="!text-center">{{ session.name }}</td>
                    <td class="!text-center">{{ session.exercisesCount }}</td>
                    <td class="!text-center">{{ session.duration | duration }}</td>
                    <td>
                      <div class="flex flex-row">
                        <p class="max-w-xs text-sm break-words whitespace-pre-wrap">{{ session.notes }}</p>
                      </div>
                    </td>
                    <td>
                      <div class="flex justify-end">
                        <p-button [label]="'details' | translate" (click)="onShowBreathSession(session)"></p-button>
                      </div>
                    </td>
                  </tr>
                </ng-template>
                <ng-template #emptymessage>
                  <tr>
                    <td colspan="5">{{ 'primeng.emptyMessage' | translate }}</td>
                  </tr>
                </ng-template>
              </p-table>
            </p-tabpanel>
            }

            <p-tabpanel value="6">
              <p-table [value]="reports"
                       [paginator]="true" [rows]="10" [rowsPerPageOptions]="[5, 10, 25]"
                       [scrollable]="true" scrollHeight="flex"
                       stripedRows
                       class="flex h-full min-h-0 flex-col">
                <ng-template #header>
                  <tr>
                    <th pSortableColumn="timeStamp" style="width: 25%">
                      <div class="flex items-center gap-2">
                        {{ 'date' | translate }}
                        <p-sort-icon field="timeStamp" />
                      </div>
                    </th>
                    <th pSortableColumn="timeStampEnd" style="width: 25%">
                      <div class="flex items-center gap-2">
                        {{ 'date' | translate }}
                        <p-sort-icon field="timeStampEnd" />
                      </div>
                    </th>
                    <th style="width: 20%">Report</th>
                    <th></th>
                  </tr>
                </ng-template>
                <ng-template #body let-report>
                  <tr>
                    <td>{{ report.timeStamp | date:'medium' }}</td>
                    <td>{{ report.timeStampEnd | date:'medium' }}</td>
                    <td>{{ report.description | translate }}</td>
                    <td>
                      <div class="flex justify-end">
                        <p-button [label]="'showReport' | translate" (click)="onShowReport(report)"></p-button>
                      </div>
                    </td>
                  </tr>
                </ng-template>
                <ng-template #emptymessage>
                  <tr>
                    <td colspan="5">{{ 'primeng.emptyMessage' | translate }}</td>
                  </tr>
                </ng-template>
              </p-table>
            </p-tabpanel>
          </p-tabpanels>
        </p-tabs>
      </div>
    </div>
  </p-card>

  <app-alert-dialog [messageService]="messageService"
                    [(visible)]="showDialogAlert"
                    [alert]="selectedAlert"
                    (closed)="onAlertDialogClosed($event)">
  </app-alert-dialog>

  <app-breath-session-dialog [messageService]="messageService"
                             [(visible)]="showDialogBreathSession"
                             [session]="selectedBreathSession"
                             (closed)="onBreathSessionDialogClosed($event)">
  </app-breath-session-dialog>

  <app-synoptic-table-dialog [messageService]="messageService"
                             [(visible)]="showSynopticTable"
                             [userId]="selectedId" [lastMeasure]="patient.lastMeasure">
  </app-synoptic-table-dialog>

  <app-acc-signals-dialog [messageService]="messageService"
                             [(visible)]="showAccelerometrSignals"
                             [userId]="selectedId" [lastMeasure]="patient.lastMeasure">
  </app-acc-signals-dialog>

  <app-breath-signals-dialog [messageService]="messageService"
                             [(visible)]="showBreathSignals"
                             [userId]="selectedId" [lastMeasure]="patient.lastMeasure">
  </app-breath-signals-dialog>

  <app-hearth-signals-dialog [messageService]="messageService"
                             [(visible)]="showHearthSignals"
                             [userId]="selectedId" [lastMeasure]="patient.lastMeasure">
  </app-hearth-signals-dialog>

</app-cardpage-base>
